<template>
    <div class="device-type-manange relative">
        <!-- 表单开始 -->
        <el-card class="box-card">
            <el-row class="inputs mg-20" :gutter="20">
                <el-col :md="6" :lg="5" :xl="4" :sm="12" :xs="24">
                    <span class="fs-14 pd-r-10">特属服务对象：</span>
                    <el-input v-model="user_name" placeholder="特属服务对象模糊搜索"/>
                </el-col>
                <el-col :md="6" :lg="6" :xl="4" :sm="12" :xs="24">
                    <span class="fs-14 pd-r-10">特属服务对象电话：</span>
                    <el-input v-model="user_mobile"  placeholder="特属服务对象电话模糊搜索"/>
                </el-col>
                <el-col :md="6" :lg="5" :xl="4" :sm="12" :xs="24">
                    <span class="fs-14 pd-r-10">会面时间：</span>
                    <el-date-picker
                            v-model="search_book_date"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd"
                            @change="dateChange"
                    ></el-date-picker>
                </el-col>
            </el-row>
            <el-row class="inputs mg-20" :gutter="20">
                <el-col :md="6" :lg="5" :xl="4" :sm="12" :xs="24">
                    <span class="fs-14 pd-r-10" ><span v-if="!is_mobile">&ensp;&ensp;&ensp;&ensp;</span>特属专家：</span>
                    <el-input v-model="doctor_name"  placeholder="特属专家模糊搜索"/>
                </el-col>
                <el-col :md="6" :lg="6" :xl="4" :sm="12" :xs="24">
                    <span class="fs-14 pd-r-10"><span v-if="!is_mobile">&ensp;&ensp;&ensp;&ensp;</span>特属专家电话：</span>
                    <el-input v-model="doctor_mobile" placeholder="特属专家电话模糊搜索"/>
                </el-col>
                <el-col :md="6" :lg="5" :xl="4" :sm="12" :xs="24">
                        <el-button @click="resetForm">重置</el-button>
                        <el-button @click="search">筛选</el-button>
                </el-col>
            </el-row>

        </el-card>
        <!-- 表单结束 -->

        <el-table :data="tableData" border style="width: 100%">
            <el-table-column width="50px" prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="200px" prop="reservation_id" label="预约编号" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="80px" prop="user_name" label="特属服务对象" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="bloc_name" label="所属集团" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="110px" prop="user_mobile" label="特属服务对象联系电话" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="110px" prop="doctor_name" label="特属专家" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="hospital_name" label="所属单位" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="110px" prop="doctor_mobile" label="特属专家联系电话" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="100px" label="预约状态" align="center" label-class-name="label">
              <template slot-scope="scope">
                <el-image :src="scope.row.status_name_icon" style="width:1rem;position: relative;top:10px;left:-3px"  fit="fill"/>
                <span>{{scope.row.status_name}}</span>
              </template>
            </el-table-column>
            <el-table-column width="100px" prop="last_meet_time" label="会面时间" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="address_info" label="会面地点" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="100px" prop="create_date" label="下单时间" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="180px" prop="admin_user_name" label="特属服务专员" align="center" v-if="role_id != 2 && child_role_id == 0"
                             label-class-name="label">
                <template slot-scope="scope">
                    <div class="cell" v-if="scope.row.admin_user_name">{{ scope.row.admin_user_name }}({{ scope.row.admin_user_mobile }})</div>
                    <div class="cell" v-else></div>
                </template>
            </el-table-column>
            <el-table-column
                prop="address"
                label="操作"
                align="center"
                label-class-name="label"
                v-slot="scope"
            >
              <el-button v-if="scope.row.isShowHandle == 1" :id="'articleSee'" @click="handle(scope.row)" type="text"
                         size="small">处理
              </el-button>
              <el-button :id="'articleSee'" @click="goDetail(scope.row)" type="text" size="small">查看</el-button>
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
                v-if="is_pagination_show"
        ></el-pagination>
    </div>
</template>
<script>
    import {getUserInfos} from '@/utils/userInfos'
    import {getFormatDate} from "@/utils/date";
    import {check} from "@/utils/checkData";
    import {authUrlCheck, isMobile} from "@/api/order";

    export default {
        data() {
            return {
                role_id: 0,
                child_role_id: 0,
                page: 1,
                perpage: 10,
                total: 0,
                status: '',
                user_name: '',
                user_mobile: '',
                doctor_name: '',
                doctor_mobile: '',
                search_book_date: '',
                start_book_date: '',
                end_book_date: '',
                reservationing_number: 0,
                reservationed_number: 0,
                reservationed_success_number: 0,
                reservationed_faile_number: 0,
                allType: [],
                tableData: [],
                is_pagination_show: true,
                is_mobile: false,
            };
        },
        created() {
            if (isMobile()) {
                this.is_mobile = true
            }
        },
        mounted() {
            let userInfo = getUserInfos()
            if (userInfo) {
                this.role_id = parseInt(userInfo.role_id)
                this.child_role_id = parseInt(userInfo.child_role_id)
            }
            let prev_page = localStorage.getItem('prev_page');

            if (prev_page == 'work_edit' || prev_page == 'work_add' || prev_page == 'work_detail') {
                localStorage.setItem('prev_page', 'work_meet_timeout')
                this.user_name = localStorage.getItem('work_meet_timeout_user_name')
                this.user_mobile = localStorage.getItem('work_meet_timeout_user_mobile')
                this.doctor_name = localStorage.getItem('work_meet_timeout_doctor_name')
                this.doctor_mobile = localStorage.getItem('work_meet_timeout_doctor_mobile')
                this.start_book_date = localStorage.getItem('work_meet_timeout_start_book_date')||''
                this.end_book_date = localStorage.getItem('work_meet_timeoute_end_book_date')||''
                if (this.start_book_date == 'undefined' || this.start_book_date == 'null') {
                    this.start_book_date = ''
                }
                if (this.end_book_date == 'undefined' || this.end_book_date == 'null') {
                    this.end_book_date = ''
                }
                if (this.user_name == 'undefined' || this.user_name == 'null') {
                    this.user_name = ''
                }
                if (this.user_mobile == 'undefined' || this.user_mobile == 'null') {
                    this.user_mobile = ''
                }
                if (this.doctor_name == 'undefined' || this.doctor_name == 'null') {
                    this.doctor_name = ''
                }
                if (this.doctor_mobile == 'undefined' || this.doctor_mobile == 'null') {
                    this.doctor_mobile = ''
                }
                this.page = parseInt(localStorage.getItem('page'))
                this.perpage = parseInt(localStorage.getItem('perpage'))
                this.search_book_date = [this.start_book_date, this.end_book_date]
                this.is_pagination_show = false;

            }
            this.getList();

        },
        methods: {

            // 预约列表
            getList() {
                let params = {
                    servername: 'Ruyi_AdminWorkbenchServices',
                    method: 'listing',
                    params: {
                        user_name: this.user_name,
                        user_mobile: this.user_mobile,
                        doctor_name: this.doctor_name,
                        doctor_mobile: this.doctor_mobile,
                        start_book_date: this.start_book_date,
                        end_book_date: this.end_book_date,
                        status: 2,
                        meet_time_out: 1,
                    },
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    }
                };
				
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                      this.tableData = [];
                      this.total = 0;
                      return;
                    }
                    let list = res.data.data.list
                    for (var i = 0; i < list.length; i++) {
                      // 以序号代替ID
                      list[i].no = (this.page - 1) * this.perpage + i + 1
                      if (!list[i].meet_date) {
                        list[i].last_meet_time = (list[i].status > 2) ? '无' : '待定';
                      } else {
                        list[i].last_meet_time = list[i].meet_date + ' ' + list[i].meet_time;
                      }
                      if (list[i].address_id < 1) {
                        list[i].address_info = (list[i].status > 2) ? '无' : '待定';
                      } else {
                        list[i].address_info = list[i].region_name + list[i].address;
                      }
                      list[i].book_date = `${list[i].book_date} ${list[i].half}`
                      switch (list[i].status) {
                        case '2':
                          list[i].status_name = '等待会面';
                          list[i].status_name_icon = require('@/assets/icon_success.png');
                          list[i].isShowHandle = 1;
                          break;

                      }
                    }

                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                });

                localStorage.setItem('work_meet_timeout_user_name', this.user_name)
                localStorage.setItem('work_meet_timeout_user_mobile', this.user_mobile)
                localStorage.setItem('work_meet_timeout_doctor_name', this.doctor_name)
                localStorage.setItem('work_meet_timeout_doctor_mobile', this.doctor_mobile)
                localStorage.setItem('work_meet_timeout_start_book_date', this.start_book_date)
                localStorage.setItem('work_meet_timeout_end_book_date', this.end_book_date)
                localStorage.setItem('prev_page', 'work_meet_timeout')
                localStorage.setItem('page', this.page)
                localStorage.setItem('perpage', this.perpage)
                this.is_pagination_show = true
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 处理预约
            handle(data) {
                if (this.role_id > 1) {
                    if (!authUrlCheck('/admin/work/WorkEdit', this.$store.getters.authUrl)) {
                        return;
                    }
                }
                this.$router.push({
                    name: "workEdit",
                    params: {
                        reservation_id: data.reservation_id,
                        user_id: data.user_id,
                        doctor_id: data.doctor_id,
                        contact_id: data.contact_id,
                        contact_mobile: data.contact_mobile,
                        book_date: data.book_date,
                        half: data.half,
                        status: data.status,
                        remark: data.remark,
                        user_mobile: data.user_mobile,
                        doctor_mobile: data.doctor_mobile,
                        assistant_id: data.assistant_id,
                        meet_date: data.meet_date,
                        meet_time: data.meet_time,
                        address_id: data.address_id,
                        user_name: data.user_name,
                        bloc_name: data.bloc_name
                    }
                });
                return;
            },

            // 跳转详情页
            goDetail(data) {
                if (this.role_id > 1) {
                    if (!authUrlCheck('/admin/work/WorkDetail', this.$store.getters.authUrl)) {
                        return;
                    }
                }
                this.$router.push({
                    name: "workDetail",
                    params: {
                        reservation_id: data.reservation_id,
                    }
                });
                return;
            },

            // 跳转添加页
            addHospitalType() {
                this.$router.push({name: "articleAdd", params: {}});
            },

            // 重置按钮
            resetForm() {
                this.user_name = "";
                this.user_mobile = "";
                this.doctor_name = "";
                this.doctor_mobile = "";
                this.start_book_date = "";
                this.end_book_date = "";
                this.search_book_date = "";
                this.status = "";
                this.page = 1;
                this.getList();
            },
            dateChange(e){
                if (!e) {
                    this.search_book_date = null
                    this.start_book_date = ''
                    this.end_book_date = ''
                }
            },
            // 搜索
            search() {

                if (this.search_book_date) {
                    this.start_book_date = this.search_book_date[0];
                    this.end_book_date = this.search_book_date[1];
                }
                this.page = 1;
                this.getList();
            },

            searchStatus(status) {
                this.status = status;
                this.page = 1;
                this.getList();
            },

            getAllData() {
                this.resetForm();
            },
            getTimeState(){
                // 获取当前时间
                let timeNow = new Date();
                // 获取当前小时
                let hours = timeNow.getHours();
                // 设置默认文字
                let state= ``;
                // 判断当前时间段
                if (hours >= 0 && hours <= 12) {
                    state = `早安`;
                } else if (hours > 12 && hours <= 18) {
                    state = `午安`;
                } else if (hours > 18 && hours <= 24) {
                    state= `晚安`;
                } 
                return state;
            },

        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";
    .el-col{
        margin-bottom: 10px;
        input{
            width: 100%;
        }
    }
    .inputs .el-input {width: 100% !important;}
</style>
